import { IS_BROWSER } from '~/app/constants'
import type { GalleryConfigIServiceConfig } from 'shared/types/gallery/config'

export const applyServiceHeaders = (config: GalleryConfigIServiceConfig): GalleryConfigIServiceConfig => {
  // No need to modify headers in the browser environment
  if (IS_BROWSER) {
    return config
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      'Accept-Encoding': 'br, gzip, deflate',
    },
  }
}
